import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Inbox, Loader2, Mail, Phone } from "lucide-react";

const fmtDate = (s) => {
  try { return new Date(s).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }); }
  catch { return ""; }
};

export default function Leads() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/leads").then(({ data }) => setRows(data)).catch(() => setRows([]));
  }, []);

  if (!rows) return <div className="flex items-center justify-center py-32"><Loader2 className="h-8 w-8 animate-spin text-navy" /></div>;

  return (
    <div data-testid="leads-page">
      <div className="mb-8">
        <p className="text-xs uppercase tracking-[0.2em] text-patriot font-bold">Inbound</p>
        <h1 className="font-display text-3xl text-navy mt-1">Leads</h1>
        <p className="text-muted-foreground mt-2">Enquiries submitted through your personal AFHA site (<span className="font-mono">/r/your-code</span>).</p>
      </div>

      {rows.length === 0 ? (
        <div className="bg-white border border-dashed border-border rounded-xl p-16 text-center" data-testid="leads-empty">
          <Inbox className="h-12 w-12 text-navy/20 mx-auto mb-4" />
          <h3 className="font-display text-xl text-navy">No leads yet</h3>
          <p className="text-muted-foreground mt-2">Share your referral link — enquiries from your site will show up here.</p>
        </div>
      ) : (
        <div className="space-y-4" data-testid="leads-list">
          {rows.map((l) => (
            <div key={l.id} data-testid={`lead-${l.id}`} className="bg-white border border-border rounded-xl p-5 sm:p-6">
              <div className="flex items-start justify-between gap-4 flex-wrap">
                <div>
                  <p className="font-semibold text-navy text-lg">{l.practice_name || l.name || "New enquiry"}</p>
                  {l.office_manager && <p className="text-sm text-muted-foreground">Office manager: {l.office_manager}</p>}
                  <div className="mt-1.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-muted-foreground">
                    <a href={`mailto:${l.email}`} className="inline-flex items-center gap-1.5 hover:text-navy"><Mail className="h-4 w-4" /> {l.email}</a>
                    {l.phone && <a href={`tel:${l.phone}`} className="inline-flex items-center gap-1.5 hover:text-navy"><Phone className="h-4 w-4" /> {l.phone}</a>}
                  </div>
                </div>
                <span className="text-xs text-muted-foreground shrink-0">{fmtDate(l.created_at)}</span>
              </div>
              <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-x-6 gap-y-2 text-sm">
                {l.address && <div><span className="text-muted-foreground">Address:</span> <span className="text-navy">{l.address}</span></div>}
                {l.npi && <div><span className="text-muted-foreground">NPI:</span> <span className="text-navy font-mono">{l.npi}</span></div>}
                {l.patient_load && <div><span className="text-muted-foreground">Avg patients/day:</span> <span className="text-navy">{l.patient_load}</span></div>}
              </div>
              {l.message && (
                <div className="mt-4 rounded-lg bg-muted/50 border border-border p-4 text-sm text-navy whitespace-pre-wrap">{l.message}</div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
